import { render, staticRenderFns } from "./train-bank.vue?vue&type=template&id=207c84ee&scoped=true&"
import script from "./train-bank.vue?vue&type=script&lang=js&"
export * from "./train-bank.vue?vue&type=script&lang=js&"
import style0 from "./train-bank.vue?vue&type=style&index=0&id=207c84ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c84ee",
  null
  
)

export default component.exports